<template>

    <div class="panel-body">
        <el-row class="column-name" justify="start">
            <span>基本信息</span>
            <div class="navbar-right">
                <el-button type="info" plain size="minimum" @click="jump2Report()" v-if="hasReport">跳转事件报告</el-button>
            </div>
        </el-row>
        <el-row>
            <el-form label-position="right" :model="formDetail" ref="formDetailRef" label-width="120px" :rules="rules">

                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="数据中心" prop="dcnum">
                            <SysroomSelectNew v-model="formDetail.dcnum"
                                              :clearable="true"
                                              :filterable="true"
                                              size="small"
                                              :disabled="formDisable"
                                              class="width70">
                            </SysroomSelectNew>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="事件来源" prop="source">
                            <domain-select v-model="formDetail.source" domainid="TICKETSOURCE" size="small"
                                           :disabled="formDisable" class="width70" :clearable="true"></domain-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="事件编号" prop="ticketid">
                            <el-input v-model="formDetail.ticketid"
                                      class="width70"
                                      size="small"
                                      disabled="true"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="事件主题" prop="description">
                            <el-input v-model="formDetail.description"
                                      class="width70"
                                      size="small"
                                      :disabled="formDisable"
                                      maxlength="60"
                                      placeholder="事件发生时间，事件发生主体，事件现象（限60字符）">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="24" :md="24" :lg="24">
                        <el-form-item label="事件详情" prop="memo">
                            <el-input v-model="formDetail.memo"
                                      class="width80"
                                      size="small"
                                      :disabled="formDisable"
                                      maxlength="512"
                                      type="textarea"
                                      rows="5"
                                      placeholder="限512字符">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="事件等级" prop="level">
                            <domain-select v-model="formDetail.level" domainid="TICKETLEVEL" size="small"
                                           :disabled="formDisable" class="width70" clearable="true"></domain-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="事件类型" prop="tickettype">
                            <el-select v-model="formDetail.tickettype"
                                       @change="ticketTypeChangeHandlerWithInit"
                                       :filterable="true"
                                       :clearable="true"
                                       :disabled="formDisable"
                                       size="small"
                                       class="width70">
                                <el-option v-for="item in tickettypeArr"
                                           :label="item.description"
                                           :value="item.failurecodeid + '_' + item.failurecode"
                                           :key="item.failurecodeid + '_' + item.failurecode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="事件开始时间" prop="actualstart">
                            <el-date-picker
                                    v-model="formDetail.actualstart"
                                    :disabled="formDisable"
                                    size="small"
                                    class="width70"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="事件开始时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="事件恢复时间" prop="actualfinish">
                            <el-date-picker
                                    v-model="formDetail.actualfinish"
                                    :disabled="formDisable"
                                    size="small"
                                    class="width70"
                                    type="datetime"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    placeholder="事件恢复时间">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="故障类别" prop="failuretype">
                            <el-select v-model="formDetail.failuretype"
                                       @change="failureTypeChangeHandlerWithInit"
                                       :filterable="true"
                                       :clearable="true"
                                       :disabled="formDisable"
                                       size="small"
                                       class="width70">
                                <el-option v-for="item in failureTypeArr"
                                           :label="item.description"
                                           :value="item.failurelist + '_' + item.failurecode"
                                           :key="item.failurelist + '_' + item.failurecode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="关联设备" prop="assetid">
                            <el-input v-model="formDetail.assetid" size="small"
                                      class="width70" style="display: none;"></el-input>
                            <el-input v-model="formDetail.assetDescription" size="small" class="width50"
                                      disabled=true>
                            </el-input>
                            <el-button icon="el-icon-edit-outline" size="mini"
                                       :disabled="formDisable"
                                       @click="dialogSingleEquipmentVisible=true">
                            </el-button>
                            <el-button icon="el-icon-delete" size="mini"
                                       @click="deleteEquipment()" :disabled="formDisable"></el-button>
                            <el-button size="mini" :disabled="!formDetail.ticketuid" @click="gotoLink">定位设备</el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="故障现象" prop="failurecode">
                            <el-select v-model="formDetail.failurecode"
                                       @change="failureCodeChangeHandlerWithInit"
                                       :filterable="true"
                                       :clearable="true"
                                       :disabled="formDisable"
                                       size="small"
                                       class="width70">
                                <el-option v-for="item in failureCodeArr"
                                           :label="item.description"
                                           :value="item.failurelist + '_' + item.failurecode"
                                           :key="item.failurelist + '_' + item.failurecode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="关联位置" prop="location">
                            <el-input v-model="formDetail.location" size="small"
                                      class="width70" style="display: none;"></el-input>
                            <el-input v-model="formDetail.locationDescription" size="small"
                                      class="width50" disabled=true>
                            </el-input>
                            <el-button icon="el-icon-edit-outline" size="mini"
                                       :disabled="formDisable"
                                       @click="locationTreeDialogVisible=true">
                            </el-button>
                            <el-button icon="el-icon-delete" size="mini"
                                       @click="deleteLocation()" :disabled="formDisable"></el-button>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="故障原因" prop="problemcode">
                            <el-select v-model="formDetail.problemcode"
                                       filterable=true
                                       clearable=true
                                       :disabled="formDisable"
                                       size="small"
                                       class="width70">
                                <el-option v-for="item in problemCodeArr"
                                           :label="item.description"
                                           :value="item.failurecode"
                                           :key="item.failurecode">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="录入人员" prop="ticketEnterBy">
                            <el-input v-model="formDetail.enterby"
                                      class="width70"
                                      size="small"
                                      disabled=true></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
        </el-row>

        <Attachment v-if="formDetail.ticketuid != null"
                    ref="attachmentRef"
                    ownerTable='TICKET'
                    docType='TICKET'
                    :ownerId='formDetail.ticketuid'
                    :existed="formDetail.ticketuid != null"
                    maxSize="2"
                    @afterAttachDownloadFunc="afterAttachDownloadFunc"
                    :disabled="canModiAttachment">
        </Attachment>

        <el-row v-if="formDetail.enterbyusername == 'incident'">
            <b>监控系统接入时间：{{formDetail.enterdate}}</b>
        </el-row>

        <el-row class="column-name" justify="start" v-if="formDetail.ticketuid != null">
            <span>流转信息</span>
        </el-row>
        <el-row v-if="formDetail.ticketuid != null">
            <Workflow
                    ref="ticketWorkflowInfoRef"
                    :bussiness="formDetail.enterbyusername == 'incident' ? 'INCIDENT3' : 'INCIDENT'"
                    :useNewApi='true'
                    :bussinessId="formDetail.ticketuid">
            </Workflow>
        </el-row>

        <template v-if="formDetail.ticketuid != null">
            <el-row class="column-name" justify="start">
                <span>事件追踪</span>
                <div class="navbar-right">
                    <el-button type="info" plain size="minimum" @click="addTicketTrackInfo">新增事件追踪</el-button>
                </div>
            </el-row>
            <el-row>
                <TrackInfoList ref="trackInfoListRef"
                               :ownerId="formDetail.ticketuid"
                               :ownerTable="'TICKET'">
                </TrackInfoList>
            </el-row>
        </template>

        <div>
            <EquipmentDialog ref="EquipmentDialog" @change="afterEquipmentDialogFunc"></EquipmentDialog>
            <LocationDialog ref="LocationDialog" @change="afterLocationDialogFunc"></LocationDialog>
            <TrackInfoDialog :ownerId="formDetail.ticketuid" :ownerTable="'TICKET'"
                             :docType="'TRACKINFO_TICKET'"
                             :visible.sync="trackInfoVisible"
                             @afterInsertTrackInfo="afterInsertTrackInfo">
            </TrackInfoDialog>
        </div>

        <br>

        <div v-if="ticketEvalArr.length > 1">
            <el-row class="column-name" justify="start">
                <span>事件处理信息</span>
            </el-row>
            <el-form label-position="right" label-width="120px">
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="创建有效性">
                            <div class="width70">
                                <dictionary-select v-model="ticketEvalArr[0].validation"
                                                   :factory-name="'domain'"
                                                   :params="'VALIDATION'"
                                                   :disabled="true"
                                                   size="small">
                                </dictionary-select>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="创建人员">
                            <el-select :value="ticketEvalArr[0].evalby.split(',')"
                                       :multiple="true"
                                       size="small"
                                       :disabled="true"
                                       placeholder="请选择"
                                       class="width70">
                                <el-option
                                        v-for="item in createUsers"
                                        :key="item.username"
                                        :label="item.realname"
                                        :value="item.username">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="处理有效性" prop="handleValidation">
                            <div class="width70">
                                <dictionary-select v-model="ticketEvalArr[1].validation"
                                                   :factory-name="'domain'"
                                                   :params="'VALIDATION'"
                                                   :disabled="true"
                                                   size="small">
                                </dictionary-select>
                            </div>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="处理人员" prop="handleUser">
                            <el-select :value="ticketEvalArr[1].evalby.split(',')"
                                       :multiple="true"
                                       size="small"
                                       placeholder="请选择"
                                       :disabled="true"
                                       class="width70">
                                <el-option
                                        v-for="item in handleUsers"
                                        :key="item.username"
                                        :label="item.realname"
                                        :value="item.username">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :xs="24" :sm="24" :md="12" :lg="12">
                        <el-form-item label="历时">
                            <el-input v-model="ticketEvalArr[0].useTime"
                                      class="width70"
                                      size="small"
                                      :disabled="true">
                            </el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </div>

        <equipment-table-dialog :visible.sync="dialogSingleEquipmentVisible"
                                :roomId="formDetail.dcnum"
                                :singleFlag="true"
                                @afterSingleSelectFunc="selectedEquipmentHandler">
        </equipment-table-dialog>

        <location-tree-dialog ref="locationTreeDialogRef"
                              :roomId="formDetail.dcnum"
                              :locationTreeDialogVisible.sync="locationTreeDialogVisible"
                              @afterSelectedNode="selectedLocationHandler">
        </location-tree-dialog>
    </div>

</template>

<script>

import SysroomSelectNew from '@/components/sysroomNew'
import DomainSelect from '@/components/domainaln'
import TicketServer from '@/api/ticket';
import EquipmentDialog from "@/components/common/EquipmentPicker";
import LocationDialog from "@/components/common/LocationPicker";
import Attachment from '@/components/attachment'
import Workflow from '@/components/workflow'
import WorkflowDialog from '@/components/workflow/workflowDialog'
import WorkflowRequestBtn from '@/components/workflow/workflowRequestBtn'
import TrackInfoDialog from '@/components/attachment/trackInfoDialog'
import TrackInfoList from '@/components/attachment/trackInfoList'
import AutokeyApi from "@/api/autokey/autokey";
import {formatDate, parseDate} from "element-ui/src/utils/date-util";
import CommonServiceApi from "@/api/commonService";
import DictionarySelect from '@/components/common/DictionarySelect'
import DictionaryText from '@/components/common/DictionaryText'
import DcimServer from "../../api/dcim";
import EquipmentTableDialog from "@/views/equipment/point/equipment-table-dialog";
import locationTreeDialog from "@/components/dcim/locationTreeDialog";

export default {
        name: "ticketDetail",

        components: {
            SysroomSelectNew,
            DomainSelect,
            EquipmentDialog,
            LocationDialog,
            Attachment,
            Workflow,
            WorkflowDialog,
            WorkflowRequestBtn,
            TrackInfoDialog,
            TrackInfoList,
            DictionarySelect,
            DictionaryText,
            EquipmentTableDialog,
            locationTreeDialog,
        },

        props: {
            ticketId: {
                type: String,
            },
        },

        data() {
            return {

                tickettypeArr: [],      //事件类型
                failureTypeArr: [],     //故障类别
                failureCodeArr: [],     //故障现象
                problemCodeArr: [],     //故障原因

                ticketEvalArr: [],

                trackInfoVisible: false,

                formDetail: {
                    dcnum: '',
                    source: '',
                    ticketid: '',
                    ticketuid: null,
                    description: '',
                    memo: '',
                    level: '',
                    tickettype: '',     //事件类型
                    actualstart: null,
                    actualfinish: null,
                    assetid: '',       //关联设备id
                    assetnum: '',       //dcim中的equipmentid
                    location: '',       //关联位置
                    failuretype: '',    //故障类别
                    failurecode: '',    //故障现象
                    problemcode: '',    //故障原因
                    enterby: localStorage.getItem("realname"),
                    enterbyusername: localStorage.getItem("username"),
                    trackdate: '',
                    status: '',
                    statusdate: '',
                    reportNum: '',

                    assetDescription: '',
                    locationDescription: '',
                },

                createUsers: [],
                handleUsers: [],
                channel: new BroadcastChannel('graph'),
                rules: {
                    dcnum: [
                        {required: true, message: '请选择数据中心', trigger: 'change'},
                    ],
                    source: [
                        {required: true, message: '事件来源', trigger: 'change'},
                    ],
                    ticketid: [
                        {required: true, message: '事件编号', trigger: 'blur'},
                    ],
                    description: [
                        {required: true, message: '事件主题', trigger: 'blur'},
                    ],
                    memo: [
                        {required: true, message: '事件详情', trigger: 'blur'},
                    ],
                    level: [
                        {required: true, message: '事件等级', trigger: 'change'},
                    ],
                    tickettype: [
                        {required: true, message: '事件类型', trigger: 'change'},
                    ],
                    actualstart: [
                        {required: true, message: '事件开始时间', trigger: 'change'},
                    ],
                    failuretype: [
                        {required: true, message: '故障类别', trigger: 'change'},
                    ],
                },

                //表单是否可用的状态
                formDisable: false,

                hasReport: false,

                dialogSingleEquipmentVisible: false,
                locationTreeDialogVisible: false,
            }
        },

        async mounted() {
            await TicketServer.ticketRestructure.queryTicketType().then(res => {
                this.tickettypeArr = res;
            });

        },

        updated(){
            this.$refs.LocationDialog.isTure = false;

            this.changeDisabledInputStyle();
        },

        methods: {
            gotoLink() {
                // TODO: 此处 graphId 会从数据上给返回，暂时写死
                this.channel && this.channel.postMessage({
                    type: 'graph',
                    paramsType: 'guid',
                    graphId: '1668253506047582208',
                    guid: '686221e7-64c7-4335-8731-bbcd89584af3',
                    // guid: this.formDetail.equipmentGuid,
                    random: Math.floor(Math.random() * 10)
                });
                // this.formDetail.equipmentGuid && window.open(window.location.origin + `/v3/graph/graph-room/display?deviceGuid=${this.formDetail.equipmentGuid}`)
            },
            changeDisabledInputStyle() {
                if (this.formDisable) {
                    let inputArr = document.getElementsByTagName('input');
                    let textareaArr = document.getElementsByTagName('textarea');
                    let combineArr = [...inputArr, ...textareaArr];
                    for (let i = 0; i < combineArr.length; i++) {
                        combineArr[i].style.color = '#3c3d40';
                        combineArr[i].style['border-color'] = "#ced1d5";
                    }
                }
            },

            // 从dcim获取设备及位置信息
            async queryDcimInfo(ticket) {
                let assetDescription = '';
                let locationDescription = '';

                if (ticket.guid != null && ticket.guid != '') {
                    let pointInfo = await DcimServer.point.findByGuid(ticket.guid);
                    if (pointInfo != null) {
                        try {
                            await DcimServer.equipment.get(pointInfo.equipmentId).then(r => {
                                assetDescription = r.name;
                            });
                        } catch (e) {
                            console.log("1.获取设备失败：" + pointInfo.equipmentId);
                        }
                        try {
                            await DcimServer.location.get(pointInfo.locationId).then(r => {
                                locationDescription = r.data.data.location;
                            });
                        } catch (e) {
                            console.log("1.获取位置失败：" + pointInfo.locationId);
                        }
                    }
                }

                if (ticket.assetnum != null && ticket.assetnum != '') {
                    try {
                        await DcimServer.equipment.get(ticket.assetnum).then(r => {
                            assetDescription = r.name;
                        });
                    } catch (e) {
                        assetDescription = '';
                        console.log("2.获取设备失败：" + ticket.assetnum);
                    }
                }
                if (ticket.location != null && ticket.location != '') {
                    try {
                        await DcimServer.location.get(ticket.location).then(r => {
                            locationDescription = r.data.data.description;
                        });
                    } catch (e) {
                        locationDescription = '';
                        console.log("2.获取位置失败：" + ticket.location);
                    }
                }

                ticket.assetDescription = assetDescription;
                ticket.locationDescription = locationDescription;
                return ticket;
            },

            async queryTicketDetail(ticketId) {
                let self = this;

                try {
                    self.$refs['formDetailRef'].resetFields();
                } catch (e) {

                }

                let ticketInfo = null;
                let res = await TicketServer.ticketRestructure.queryByTicketId(ticketId);
                res.ticket.dcnum = parseInt(res.ticket.dcnum);

                await self.ticketTypeChangeHandler(res.ticket.tickettype);
                await self.failureTypeChangeHandler(res.ticket.failuretype);
                await self.failureCodeChangeHandler(res.ticket.failurecode);

                // ticketInfo = res.ticket;
                self.ticketEvalArr = res.ticketEvalList;

                if (res.ticket.reportNum != '') {
                    this.hasReport = true;
                } else {
                    this.hasReport = false;
                }

                ticketInfo = await this.queryDcimInfo(res.ticket);

                this.formDetail = ticketInfo;

                //创建有效性、处理有效性人员范围获取
                if (this.ticketEvalArr.length > 1) {
                    await CommonServiceApi.getSysuserList(this.formDetail.dcnum).then(res => {
                        self.createUsers = res.data;
                        self.handleUsers = res.data;
                    });
                }

                this.$nextTick(() => {
                    this.$refs['attachmentRef'].downloadList('TICKET', this.formDetail.ticketuid);
                    this.$refs['ticketWorkflowInfoRef'].getHistoryList();
                    this.$refs['trackInfoListRef'].getTrackInfoList(this.formDetail.ticketuid);
                });

                //调用父页面方法显示当前详情事件的工作流状态
                this.$emit('loadedEventInfos', {'ticket': ticketInfo});
            },

            ticketTypeChangeHandlerWithInit(ticketTypeStr) {
                this.formDetail.failuretype = '';
                this.formDetail.failurecode = '';
                this.formDetail.problemcode = '';
                this.ticketTypeChangeHandler(ticketTypeStr);
            },

            /**
             * 根据事件类型的选择，获取故障类别列表
             */
            ticketTypeChangeHandler(ticketTypeStr) {
                let ticketType = ticketTypeStr.split('_')[1];
                return TicketServer.ticketRestructure.queryFailureTypeInfo(ticketType).then(res => {
                    this.failureTypeArr = res;
                });
            },

            failureTypeChangeHandlerWithInit(failureTypeStr) {
                this.formDetail.failurecode = '';
                this.formDetail.problemcode = '';
                this.failureTypeChangeHandler(failureTypeStr);
            },

            /**
             * 根据故障类别获取故障现象列表
             */
            failureTypeChangeHandler(failureTypeStr) {
                let failureType = failureTypeStr.split('_')[1];
                return TicketServer.ticketRestructure.queryFailureCodeInfo(failureType).then(res => {
                    this.failureCodeArr = res;
                    this.problemCodeArr = [];
                });
            },

            failureCodeChangeHandlerWithInit(failureCodeStr) {
                this.formDetail.problemcode = '';
                this.failureCodeChangeHandler(failureCodeStr);
            },

            /**
             * 根据故障现象获取故障原因列表
             */
            failureCodeChangeHandler(failureCodeStr) {
                let id = failureCodeStr.split('_')[0];
                return TicketServer.ticketRestructure.queryProblemcodes(id).then(res => {
                    res = res.map(e => {
                        return {
                            'failurecode': e.data.code,
                            'description': e.data.description,
                        }
                    });
                    this.problemCodeArr = res;
                });
            },

            openEquipment() {
                this.$refs.EquipmentDialog.dialogVisible = true;
                this.$refs.EquipmentDialog.pageSearch.search.roomId = this.formDetail.dcnum;
                this.$refs.EquipmentDialog.pageSearch.search.appId = 'WEB';
                this.$refs.EquipmentDialog.pageSearch.search.token = localStorage.getItem("token");
                if (this.formDetail.failuretype != '') {
                    this.$refs.EquipmentDialog.pageSearch.search.assetType = this.formDetail.failuretype.split('_')[1];
                }

                this.$refs.EquipmentDialog.queryByPage();
            },

            deleteEquipment() {
                this.formDetail.assetnum = null;
                this.formDetail.assetDescription = null;
            },

            afterEquipmentDialogFunc(row) {
                this.formDetail.assetid = row.assetId;
                this.formDetail.assetDescription = row.assetTag;
                if (row.location != null) {
                    this.formDetail.location = row.location.location;
                    this.formDetail.locationDescription = row.location.description;
                }
            },

            afterLocationDialogFunc(row) {
                this.formDetail.location = row.location;
                this.formDetail.locationDescription = row.description;
            },

            openLocation() {
                this.$refs.LocationDialog.dialogVisible = true;
                this.$refs.LocationDialog.pageSearch.search.roomid = this.formDetail.dcnum;
                this.$refs.LocationDialog.queryByPage();
            },

            deleteLocation() {
                this.formDetail.location = '';
                this.formDetail.locationDescription = '';
            },

            async insert() {
                let tmpFormData = {...this.formDetail};
                tmpFormData.tickettype = tmpFormData.tickettype.split('_')[1];
                tmpFormData.failuretype = tmpFormData.failuretype.split('_')[1];
                tmpFormData.failurecode = tmpFormData.failurecode.split('_')[1];
                return TicketServer.ticketRestructure.insert(tmpFormData);
            },

            async update() {
                let tmpFormData = {...this.formDetail};
                tmpFormData.tickettype = tmpFormData.tickettype.split('_')[1];
                tmpFormData.failuretype = tmpFormData.failuretype.split('_')[1];
                tmpFormData.failurecode = tmpFormData.failurecode.split('_')[1];
                return TicketServer.ticketRestructure.update(tmpFormData);
            },

            async saveCheck() {
                let result = false;
                if (this.checkCanSave()) {
                    let valid = await this.$refs['formDetailRef'].validate();
                    if (valid) {
                        result = true;
                    }
                }
                return result;
            },

            async save() {
                let result = false;
                if (this.formDetail.ticketuid == null) {
                    await this.insert().then(res => {
                        if (res.data.code == 200) {
                            result = true;
                            this.$message.success("新增成功");
                        }
                    });
                } else {
                    await this.update().then(res => {
                        if (res.data.code == 200) {
                            result = true;
                            this.$message.success("更新成功");
                        }
                    });
                }
                await this.queryTicketDetail(this.formDetail.ticketid);
                return result;
            },

            checkCanSave() {
                if ((this.formDetail.actualstart != null && this.formDetail.actualstart != '') && (this.formDetail.actualfinish != null && this.formDetail.actualfinish != '')) {
                    if (parseDate(this.formDetail.actualstart, "yyyy-MM-dd HH:mm:ss") > parseDate(this.formDetail.actualfinish, "yyyy-MM-dd HH:mm:ss")) {
                        this.$message.error("事件的开始时间要小于等于恢复时间");
                        return false;
                    }
                }

                if (this.formDetail.level == 'LEVEL1' || this.formDetail.level == 'LEVEL2') {
                    if (this.formDetail.failurecode == '') {
                        this.$message.error('一、二级事件故障现象必填项!');
                        return false;
                    }
                    if (this.formDetail.problemcode == '') {
                        this.$message.error('一、二级事件故障原因必填项!');
                        return false;
                    }
                }
                return true;
            },

            delete() {
                if ('DRAFT' == this.formDetail.status) {
                    TicketServer.ticketRestructure.delete(this.formDetail).then(res => {
                        if (res.data.code == 200) {
                            this.$message.success('删除成功');
                            this.$emit('loadedEventInfos', null);
                        }
                    });
                } else {
                    this.$message.error('非草稿状态禁止删除！');
                }
            },

            afterAttachDownloadFunc(fileList) {

            },

            addTicketTrackInfo() {
                this.trackInfoVisible = true;
            },

            afterInsertTrackInfo() {
                this.trackInfoVisible = false;
                this.$refs['trackInfoListRef'].getTrackInfoList(this.formDetail.ticketuid);
            },

            init() {
                this.formDetail = {
                    dcnum: '',
                    source: '',
                    ticketid: '',
                    ticketuid: null,
                    description: '',
                    memo: '',
                    level: '',
                    tickettype: '',     //事件类型
                    actualstart: formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    actualfinish: null,
                    assetid: '',       //关联设备id
                    location: '',       //关联位置
                    failuretype: '',    //故障类别
                    failurecode: '',    //故障现象
                    problemcode: '',    //故障原因
                    enterby: localStorage.getItem("realname"),
                    enterbyusername: localStorage.getItem("username"),
                    trackdate: formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    status: null,
                    statusdate: formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss'),
                    assetDescription: '',
                    locationDescription: '',
                }

                this.ticketEvalArr = [];

                this.$refs['formDetailRef'].resetFields();
                this.formDetail.assetDescription = '';
                this.formDetail.locationDescription = '';
                this.formDetail.status = 'DRAFT';
                try {
                    this.$refs['attachmentRef'].fileList = [];
                    this.$refs['ticketWorkflowInfoRef'].historyList = [];
                    this.$refs['trackInfoListRef'].trackInfoList = [];
                } catch (e) {

                }

                AutokeyApi.gen("TICKETNUM2").then(res => {
                    this.formDetail.ticketid = res;
                });
            },

            jump2Report() {
                let url = process.env.VUE_APP_WEB_API + "/athub" + "/event/report.html?reportnum=" + this.formDetail.reportNum + "&appId=WEB&token=" + localStorage.getItem("token");
                window.open(url);
            },

            selectedEquipmentHandler(equipmentInfo) {
                this.formDetail.assetnum = equipmentInfo.id;
                this.formDetail.assetDescription = equipmentInfo.name;
            },

            selectedLocationHandler(nodeInfo) {
                this.formDetail.location = nodeInfo.referenceId;
                this.formDetail.locationDescription = nodeInfo.name;
                this.locationTreeDialogVisible = false;
            },
        },

        watch: {
            ticketId: {
                immediate: true,
                handler: function (newVal, oldVal) {
                    if (newVal != null && newVal != '') {
                        this.queryTicketDetail(newVal);
                    }
                }
            },
        },

        //指定异步方法
        async created() {

        },

        computed: {
            canModiAttachment() {
                //已关闭或已撤销的事件，不允许添加附件
                if (this.formDetail.status == 'CLOSE' || this.formDetail.status == 'CANCEL') {
                    return true;
                }
                return false;
            }
        },
        unmounted() {
            this.channel && this.channel.close();
        },
    }
</script>

<style scoped>

/*    .el-input.is-disabled >>> .el-input__inner {
        color: #606266;
    }

    .el-textarea.is-disabled >>> .el-textarea__inner {
        color: #606266;
    }*/

</style>
